import React from 'react';
import {
  initEditorValuesBranch,
  initTrackingValuesBranch,
  initViewValuesBranch
} from './branch/initBranchValues';
import ShortAnswerSurvey from './branch/ShortAnswerSurvey';
import ShortAnswerSurvey_0201 from './branch/ShortAnswerSurvey_0201';
import ShortAnswerSurveyTracking from './branch/ShortAnswerSurveyTracking';
import ShortAnswerSurveyTracking_0201 from './branch/ShortAnswerSurveyTracking_0201';

export const initViewValues = {
  // currentBranchIndex: '',
  currentIndex: 0,
  bg: {
    background: 'color',
    ...initViewValuesBranch?.bg
  },
  bgImage: {
    background: ['https://image.inappmessage.com/sample/undefined.png'],
    logo: [
      'https://image.inappmessage.com/sample/short_answer_survey_logo_01.png'
    ],
    ...initViewValuesBranch?.bgImage
  },
  bgColor: {
    close: ['#ffffff'],
    background: ['#000000'],
    ...initViewValuesBranch?.bgColor
  },
  deeplink: { ...initViewValuesBranch?.deeplink },
  radius: { left_button: 8, right_button: 8, ...initViewValuesBranch?.radius },

  text: {
    title: ['멤버십을 해지하는\n이유를 알려주세요!'],
    ...initViewValuesBranch?.text
  },
  fontSize: { title: 1.25, ...initViewValuesBranch?.fontSize },
  fontWeight: { title: 700, ...initViewValuesBranch?.fontWeight },
  color: { title: '#ffffff', ...initViewValuesBranch?.color },
  fontFamily: { title: 'Montserrat', ...initViewValuesBranch?.fontFamily },
  textAlign: { title: 'center', ...initViewValuesBranch?.textAlign },

  btnText: {
    option_button: [
      [
        '앱 사용이 불편해요',
        '상품 탐색이 어려워요',
        '앱 사용이 불편해요',
        '기타를 입력해주세요.'
      ]
    ],
    text_area: ['기타 불편사항을 작성해주시면 빠르게 수정해볼게요.'],
    left_button: ['아쉽지만 탈퇴하기'],
    right_button: ['계속 사용하기'],
    ...initViewValuesBranch?.btnText
  },
  btnFontSize: {
    option_button: 0.875,
    text_area: 0.75,
    selected_left_button: 0.875,
    left_button: 0.875,
    right_button: 0.875,
    ...initViewValuesBranch?.btnFontSize
  },
  btnFontWeight: {
    option_button: 500,
    text_area: 500,
    selected_left_button: 600,
    left_button: 600,
    right_button: 600,
    ...initViewValuesBranch?.btnFontWeight
  },
  btnColor: {
    option_button: '#ffffff',
    text_area: '#878787',
    radio_button: '#ffffff',
    selected_left_button: '#000000',
    left_button: '#878787',
    right_button: '#000000',
    ...initViewValuesBranch?.btnColor
  },
  btnBgColorR: {
    option_button: 0,
    text_area: 59,
    radio_button: 152,
    selected_left_button: 255,
    left_button: 59,
    right_button: 255,
    ...initViewValuesBranch?.btnBgColorR
  },
  btnBgColorG: {
    option_button: 0,
    text_area: 59,
    radio_button: 152,
    selected_left_button: 255,
    left_button: 59,
    right_button: 255,
    ...initViewValuesBranch?.btnBgColorG
  },
  btnBgColorB: {
    option_button: 0,
    text_area: 59,
    radio_button: 152,
    selected_left_button: 255,
    left_button: 59,
    right_button: 255,
    ...initViewValuesBranch?.btnBgColorB
  },
  btnBgColorA: {
    option_button: 0,
    text_area: 1,
    radio_button: 1,
    selected_left_button: 1,
    left_button: 1,
    right_button: 1,
    ...initViewValuesBranch?.btnBgColorA
  },
  btnFontFamily: {
    option_button: 'Montserrat',
    text_area: 'Montserrat',
    selected_left_button: 'Montserrat',
    left_button: 'Montserrat',
    right_button: 'Montserrat',
    ...initViewValuesBranch?.btnFontFamily
  }
};

export const initTrackingValues = {
  tracking: {
    close: ['close button 1'],
    option_button: [['option 1-1', 'option 1-2', 'option 1-3', 'option 1-4']],
    text_area: ['textarea 1'],
    left_button: ['left button 1'],
    right_button: ['right button 1'],
    ...initTrackingValuesBranch?.tracking
  },
  logCustom: {
    type: [['none', 'none', 'none', 'none']],
    option_button: [['log_name', 'log_name', 'log_name', 'log_name']],
    ...initTrackingValuesBranch?.logCustom
  }
};

export const init_editor_values_short_answer_survey = {
  branch: [1, 1],
  contents: {
    bgImageType: ['background', 'logo'],
    bgColorType: ['close', 'background'],
    bg: ['background'],
    bgImage: ['logo'],
    bgColor: ['close'],

    textType: ['title'],
    text: ['title'],
    fontSize: ['title'],
    fontWeight: ['title'],
    color: ['title'],
    fontFamily: ['title'],
    textAlign: ['title']
  },
  buttons: {
    btnType: [
      'option_button',
      'text_area',
      'radio_button',
      'selected_left_button',
      'left_button',
      'right_button'
    ],
    optionText: ['option_button'],
    btnText: [
      undefined,
      'text_area',
      undefined,
      undefined,
      'left_button',
      'right_button'
    ],
    btnFontSize: [
      'option_button',
      'text_area',
      undefined,
      'selected_left_button',
      'left_button',
      'right_button'
    ],
    btnFontWeight: [
      'option_button',
      'text_area',
      undefined,
      'selected_left_button',
      'left_button',
      'right_button'
    ],
    btnColor: [
      'option_button',
      'text_area',
      'radio_button',
      'selected_left_button',
      'left_button',
      'right_button'
    ],
    btnBgColor: [
      undefined,
      'text_area',
      'radio_button',
      'selected_left_button',
      'left_button',
      'right_button'
    ],
    btnFontFamily: [
      'option_button',
      'text_area',
      undefined,
      'selected_left_button',
      'left_button',
      'right_button'
    ],
    radius: [
      undefined,
      undefined,
      undefined,
      undefined,
      'left_button',
      'right_button'
    ],
    radiusMax: [undefined, undefined, undefined, undefined, 30, 30]
  },
  trackings: {
    trackingType: [
      'close',
      'option_button',
      'text_area',
      'left_button',
      'right_button'
    ],
    logCustomType: ['type', 'option_button']
  },
  ...initEditorValuesBranch
};

export const ViewTemplates = {
  '': <ShortAnswerSurvey />,
  '0201': <ShortAnswerSurvey_0201 />
};

export const TrackingTemplates = {
  '': <ShortAnswerSurveyTracking />,
  '0201': <ShortAnswerSurveyTracking_0201 />
};
